import { doc, getDoc, getFirestore } from "firebase/firestore";

export const getDefiData = async () => {
  try {
    const response = await fetch(
      "https://us-central1-stader-landing-ui.cloudfunctions.net/app/defi/polygon"
    );

    const resp = await response.json();

    return resp;
  } catch (error) {
    return {};
  }
};

export const getBannerData = async () => {
  try {
    const db = getFirestore();

    const docRef = doc(db, "details", "banner");

    const docSnap = await getDoc(docRef);

    let data: any = {};

    if (docSnap.exists()) {
      data = docSnap.data();
    }

    return data;
  } catch (error) {
    return {
      error,
    };
  }
};

// export const getBannerData = async () => {
//   try {
//     const db = getFirestore();

//     const snapshot = await getDocs(collection(db, "defi"));

//     const data: any = {};

//     snapshot.forEach((doc) => {
//       if (doc) {
//         const docData = doc.data();

//         data[doc.id] = docData;
//       }
//     });

//     return data;
//   } catch (error) {
//     return {
//       error,
//     };
//   }
// };
